/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";

import { ExploreLink, ProfileImage, Text } from "UpduoLibrary";
import { skaleWebTextLightGray } from "config/UpduoColors";

import Icon from "react-icons-kit";
import { Icon as MaterialIcon } from "@mdi/react";
import { calendar } from "react-icons-kit/fa/calendar";
import { group } from "react-icons-kit/fa/group";
import { mapMarker } from "react-icons-kit/fa/mapMarker";
import { mdiTie } from "@mdi/js";

interface UserCellProps {
  isVideo?: boolean;
  title?: string;
  user: any; //TODO what type should this be?
  summit?: any;
  isIncomplete?: boolean;
  callback?: () => void;
  orgType?: "S" | "C";
  isGraphql?: boolean;
  width?: number;
  hasTooltip?: boolean;
}

export default function UserCell({
  isVideo = false,
  title = "",
  user,
  summit = null,
  isIncomplete,
  callback,
  orgType = "S",
  isGraphql = false,
  width,
  hasTooltip,
}: UserCellProps) {
  const userStoreName = user.store?.name || "";
  const cohortName = user.cohort?.name || "";
  const summitName = summit?.name || "";
  if (isGraphql) {
    const { profile_img_sm_url: profileImgSmUrl, ...rest } = user;
    user = { profileImgSmUrl, ...rest };
  }
  return (
    <View
      style={{
        flexDirection: "row",
        alignItems: "center",
      }}
    >
      <ProfileImage userObject={user} size={isVideo ? 35 : 40} />
      <View style={{ width: 20 }} />
      <View>
        <View>
          <Text style={{ color: skaleWebTextLightGray, fontSize: 10 }}>
            {title}
          </Text>
          <View style={{ width: width }}>
            <Text
              style={{ fontWeight: isVideo ? "bold" : "normal" }}
              numberOfLines={1}
            >
              <ExploreLink
                isIncomplete={isIncomplete}
                tooltipId={`user_${user.id}`}
                text={
                  isGraphql
                    ? `${user.firstName} ${user.lastName}`
                    : `${user.first_name} ${user.last_name}`
                }
                to={`/dashboard/user/${user.id}`}
                hasTooltip={hasTooltip}
                callback={callback}
              />
            </Text>
          </View>
        </View>

        <View style={{ paddingTop: 3 }}>
          {orgType === "C" && userStoreName ? (
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                height: 20,
                width: width,
              }}
            >
              <div style={{ color: skaleWebTextLightGray }}>
                <Icon size={12} icon={mapMarker} />
              </div>
              <Text
                style={{
                  color: skaleWebTextLightGray,
                  fontSize: 10,
                  paddingLeft: 2,
                }}
                ellipsizeMode={"tail"}
                numberOfLines={1}
              >
                {userStoreName.length > 1
                  ? userStoreName.substring(0, 1).toUpperCase() +
                    userStoreName.substring(1)
                  : userStoreName.toUpperCase()}
              </Text>
            </View>
          ) : null}

          {
            orgType === "C" && user.title ? (
              <View
                style={{
                  flexDirection: "row",
                  alignItems: "center",
                  height: 20,
                  width: width,
                }}
              >
                <MaterialIcon
                  path={mdiTie}
                  size={0.5}
                  color={skaleWebTextLightGray}
                />
                <Text
                  style={{
                    color: skaleWebTextLightGray,
                    fontSize: 10,
                    paddingLeft: 2,
                  }}
                  ellipsizeMode={"tail"}
                  numberOfLines={1}
                >
                  {user.title.length > 1
                    ? user.title.substring(0, 1).toUpperCase() +
                      user.title.substring(1)
                    : user.title.toUpperCase()}
                </Text>
              </View>
            ) : null
            // (
            //   <View style={{ height: 20 }}></View>
            // )
          }

          {orgType === "C" && cohortName ? (
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                height: 20,
                width: width,
              }}
            >
              <div style={{ color: skaleWebTextLightGray }}>
                <Icon size={12} icon={group} />
              </div>
              <Text
                style={{
                  color: skaleWebTextLightGray,
                  fontSize: 10,
                  paddingLeft: 2,
                }}
                ellipsizeMode={"tail"}
                numberOfLines={1}
              >
                {cohortName}
              </Text>
            </View>
          ) : null}

          {orgType === "C" && summitName ? (
            <View
              style={{
                flexDirection: "row",
                alignItems: "center",
                height: 20,
                width: width,
              }}
            >
              <div style={{ color: skaleWebTextLightGray }}>
                <Icon size={12} icon={calendar} />
              </div>
              <Text
                style={{
                  color: skaleWebTextLightGray,
                  fontSize: 10,
                  paddingLeft: 2,
                }}
                ellipsizeMode={"tail"}
                numberOfLines={1}
              >
                {summitName}
              </Text>
            </View>
          ) : null}

          {orgType === "C" && !userStoreName && (
            <View style={{ height: 20 }}></View>
          )}
        </View>
      </View>
    </View>
  );
}
